import { render, staticRenderFns } from "./TheRecentThankYouNotes.vue?vue&type=template&id=446b3214&scoped=true"
import script from "./TheRecentThankYouNotes.vue?vue&type=script&lang=js"
export * from "./TheRecentThankYouNotes.vue?vue&type=script&lang=js"
import style0 from "./TheRecentThankYouNotes.vue?vue&type=style&index=0&id=446b3214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446b3214",
  null
  
)

export default component.exports